import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { selectorMenuProps } from './utils';
var options = [
    React.createElement(MenuItem, { key: "booleanFilter_ALL", value: "" },
        React.createElement("span", { className: "boolFilterMenuItem" }, "All")),
    React.createElement(MenuItem, { key: "booleanFilter_Y", value: "true" },
        React.createElement("span", { className: "boolFilterMenuItem" }, "Yes")),
    React.createElement(MenuItem, { key: "booleanFilter_N", value: "false" },
        React.createElement("span", { className: "boolFilterMenuItem" }, "No")),
];
var BoolFilter = function (_a) {
    var boolColumn = _a.boolColumn, onFilterChange = _a.onFilterChange;
    var handleOnChange = function (event) {
        onFilterChange(boolColumn, event.target.value);
    };
    return (React.createElement(Select, { className: "columnFilter boolFilter", fullWidth: true, disableUnderline: true, displayEmpty: true, disabled: !boolColumn.filterable, MenuProps: selectorMenuProps, name: boolColumn.name, value: boolColumn.filter !== null && boolColumn.filter !== undefined ? boolColumn.filter : '', children: options, onChange: handleOnChange }));
};
export default BoolFilter;
//# sourceMappingURL=BoolFilter.js.map